export function sessionReducer(state = {
    ALL:{},
    CURRENT: []
} ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_SESSION":            
        case "UPDATE_SESSION":
            let list = Object.assign({}, state);
            list.ALL[payload.session_id] = payload
        
            return list
            
        case "GET_SESSIONS":
            let list2 = Object.assign({}, state);
            list2.ALL = payload
        
            return list2
        case "GET_CURRENT_SESSION":
            let list3 = Object.assign({}, state);
            list3.CURRENT = payload
        
            return list3

            
        default:
            return state;
    }
    
}